<template>
  <vehicules-list vehicule-step="sortie" />

</template>

<script>

import VehiculesList from './VehiculesList.vue'

export default {
  components: {
    VehiculesList,
  },
}
</script>

<style lang="scss" scoped>

</style>
